__turbopack_context__.v({
  "checkbox": "tJ_aIa_checkbox",
  "checkbox--disabled": "tJ_aIa_checkbox--disabled",
  "checkbox-input": "tJ_aIa_checkbox-input",
  "checkbox-input--disabled": "tJ_aIa_checkbox-input--disabled",
  "checkbox-input--modified": "tJ_aIa_checkbox-input--modified",
  "checkbox-label": "tJ_aIa_checkbox-label",
});
